import React, { FC, useContext } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import Container from '@material-ui/core/Container'
import NewsletterContext from '../contexts/Newsletter'
import Link from '../components/widgets/Link'

import {
  TOPBAR_HEIGHT,
} from '../settings'


const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4),
  },
  textPaper: {
    padding: theme.spacing(4),
    backgroundColor: 'rgba(255,255,255,0.5)'
  },
}))

const Impressum: FC = ({

}) => {
  const classes = useStyles()
  
  return (
    <Container maxWidth="md" className={ classes.root }>
      <Paper className={ classes.textPaper }>
        <Typography gutterBottom variant="body1">
          Angaben gemäß § 5 TMG: Gavin Evans Photography UG
        </Typography>
        <Typography gutterBottom variant="body1">
          Carmerstr 1  10623 Berlin
        </Typography>
        <Typography gutterBottom variant="body1">
          +49 (0) 159 02413642
        </Typography>
        <Typography gutterBottom variant="body1">
          E-Mail: info@gavinevans.photography
        </Typography>
        <Typography gutterBottom variant="body1">
          Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:DE325004083
        </Typography>
        <Typography gutterBottom variant="body1">
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:http://ec.europa.eu/consumers/odr
        </Typography>
        <Typography gutterBottom variant="body1">
          Unsere E-Mail-Adresse finden Sie oben im Impressum.Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einerVerbraucherschlichtungsstelle teilzunehmen. Haftung für InhalteAls Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen. Haftung für LinksUnser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen. UrheberrechtDie durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw.Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
        </Typography>
        <Typography gutterBottom variant="body1">
          <strong>Vi.S.d.P.</strong>
        </Typography>
        <Typography gutterBottom variant="body1">
          Inhaltlich Verantwortlicher gemäß § 10 Absatz 3 MDStV. Gavin Evans
        </Typography>
        <Typography gutterBottom variant="body1">
          Alle Rechte vorbehalten. Alle Bildinhalte, Illustrationen, Photos, Videos und Texte © Gavin Evans
        </Typography>
      </Paper>
    </Container>
  )
}

export default Impressum